// Utilitários de crias para os mapas (lotes com qtd_crias_machos / qtd_crias_femeas)

// Texto das crias de um lote (ex: "1 macho(s), 2 fêmea(s)") ou '' se não houver
export const criasTxt = (l) => {
  const parts = []
  if (l?.qtd_crias_machos) parts.push(`${l.qtd_crias_machos} macho(s)`)
  if (l?.qtd_crias_femeas) parts.push(`${l.qtd_crias_femeas} fêmea(s)`)
  return parts.join(', ')
}

// Soma as crias de uma lista de lotes → { m, f, txt } (txt vazio se não houver crias)
export const criasTotais = (lotes) => {
  const m = (lotes || []).reduce((s, l) => s + (l?.qtd_crias_machos || 0), 0)
  const f = (lotes || []).reduce((s, l) => s + (l?.qtd_crias_femeas || 0), 0)
  return { m, f, txt: m + f > 0 ? `${m}M / ${f}F` : '' }
}
